import { faKey, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  getAllProductByVendor,
  getVendorDetailsById,
  VendorDetailSingle
} from 'api/user/vendor_requests';
import EcoimDefaultAddressCard from 'components/cards/EcoimDefaultAddressCard';
import EcomVendorDetailsCard from 'components/cards/EcomVendorDetailsCard';
import VendorDetailsTabs from 'components/modules/e-commerce/vendorDetails/VendorDetailsTabs';
import { defaultBreadcrumbItems } from 'data/commonData';
import { PF } from 'helpers/utils';
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'redux-state/store';

const VendorDetailPage = () => {
  const { id } = useParams();
  const { user } = useSelector((state: RootState) => state.auth);
  const customerDetails = useSelector(
    (state: RootState) => state.user.customer
  );
  const vendorDetails = useSelector((state: RootState) => state.user.vendor);
  const [countProduct, setCountProduct] = useState(0);

  const [vendor, setVendor] = useState<VendorDetailSingle>({
    fullName: '',
    email: '',
    phone: '',
    address: {
      street: '',
      city: '',
      state: '',
      country: '',
      postalCode: '',
      phone: ''
    },
    totalOrders: 0,
    totalRevenue: 0,
    lastOrderDate: null,
    createdAt: null,
    productsCount: 0,
    totalRatings: 0,
    totalReviews: 0,
    averageRating: 0,
    totalRankings: 0,
    userId: {
      id: '',
      fullName: '',
      email: '',
      avatar: null,
      role: 'vendor',
      createdAt: '',
      updatedAt: ''
    }
  });

  useEffect(() => {
    if (id) {
      const fetchProduct = async () => {
        try {
          const response = await getVendorDetailsById(id);
          setVendor(response);
        } catch (error) {
          toast.error('Failed to fetch vendor details');
          console.error('Failed to fetch vendor details:', error);
        }
      };

      fetchProduct();
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const fetchProduct = async () => {
        try {
          const response = await getAllProductByVendor(id);
          setCountProduct(response.count);
        } catch (error) {
          console.error('Failed to fetch product count:', error);
        }
      };

      fetchProduct();
    }
  }, [id]);

  return (
    <Container className="px-xl-0 px-xxl-3 mt-5">
      <Row className="align-items-center justify-content-between g-3 mb-4">
        <Col xs="auto">
          <h2 className="mb-0">Vendor Details</h2>
        </Col>
      </Row>
      <Row className="g-3 mb-6">
        <Col xs={12} lg={8}>
          <EcomVendorDetailsCard
            vendorId={id ?? null}
            fullName={vendor?.userId?.fullName}
            avatar={vendor?.userId?.avatar}
            createdAt={vendor?.userId?.createdAt}
            productsCount={countProduct}
            totalReview={vendor.totalReviews}
            totalRanking={vendor.totalRankings}
          />
        </Col>
        <Col xs={12} lg={4}>
          <EcoimDefaultAddressCard
            address={vendor?.address}
            email={vendor?.userId.email}
            phone={vendor?.phone}
            role="vendor"
          />
        </Col>
      </Row>
      <VendorDetailsTabs vendorId={id!} />
    </Container>
  );
};

export default VendorDetailPage;
